// extracted by mini-css-extract-plugin
module.exports = {"content":"SignedInLayout_content__YAlMt","indicator":"SignedInLayout_indicator__1UWua","placeholder":"SignedInLayout_placeholder__2TJYZ","toast":"SignedInLayout_toast__2qvlf"};